import {z} from 'zod';

export const FinancialProductUnavailableReasonSchema = z.enum([
  'NOT_YET_VALID',
  'EXPIRED',
  'ARCHIVED',
  'DELETED',
  'MISSING_CONFIGURATION',
  'MISSING_PROVIDER',
  'MISSING_VEHICLE_PRICE',
  'UNSUPPORTED_TERM',
  'UNSUPPORTED_DOWN_PAYMENT',
  'UNSUPPORTED_BALLOON_PAYMENT',
  'UNSUPPORTED_TARGET_GROUP',
  'MISSING_MATRIX_CELL',
]);
export type FinancialProductUnavailableReason = z.infer<
  typeof FinancialProductUnavailableReasonSchema
>;
